import React from 'react';

const ThesisPage: React.FC = () => {
    const strategies = [
        {
            title: "Identifying Hidden Value",
            description: "We target services businesses and software platforms that are operationally strong but technologically underleveraged. AI and system integration unlock transformative gains."
        },
        {
            title: "Creating Synergistic Portfolios",
            description: "We build vertical and horizontal ecosystems where software and service companies reinforce one another; through shared data, distribution, and infrastructure."
        },
        {
            title: "Building Sustainable Moats",
            description: "We use AI, workflow automation, and proprietary tech to establish durable cost and differentiation advantages across our rollups."
        },
        {
            title: "Optimizing GTM Efficiency",
            description: "We centralize and scale go-to-market systems (including CRM, onboarding, and pricing) to boost customer acquisition and upsell velocity across the portfolio."
        }
    ];

    return (
        <div className="max-w-6xl mx-auto px-4 py-12 md:py-24">
            <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tighter">
                Investment <span className="text-accent" style={{
                    color: '#3F013D',
                    textShadow: '1px 1px 0 #ae4094, -1px -1px 0 #000, 0px 1px 0 #ae4094, 1px 0px 0 #ae4094, 0px -1px 0 #000, -1px 0px 0 #000'
                }}>Thesis</span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl">
                Our multidimensional investment strategy creates compounding value through AI-driven integration,
                vertical expertise, and operational execution.
            </p>

            <div className="my-16 grid grid-cols-1 md:grid-cols-2 gap-12">
                <div className="space-y-6">
                    <h2 className="text-3xl font-bold">The Opportunity</h2>
                    <p className="text-gray-300">
                        The AI era is transforming every corner of the services economy; yet most verticals remain
                        analog, operationally fragmented, and inefficient. Many of these businesses generate stable
                        cash flow but lack the infrastructure, insight, or systems to scale efficiently.
                    </p>
                    <p className="text-gray-300">
                        We see opportunity not just in undervalued software, but in under-optimized industries where
                        AI integration, data leverage, and operational discipline can unlock significant value. This
                        includes legacy businesses and software vendors alike; across healthcare, compliance, field
                        services, and more.
                    </p>
                </div>

                <div className="space-y-6">
                    <h2 className="text-3xl font-bold">Our Approach</h2>
                    <p className="text-gray-300">
                        Our multidimensional strategy goes beyond traditional financial rollups. We acquire controlling
                        or influential stakes in both services businesses (OpCos) and complementary software and AI
                        platforms (TechCos), and build synergy between them.
                    </p>
                    <p className="text-gray-300">
                        We integrate AI workflows, automate core functions, and share cross-portfolio tools (from
                        routing to billing to customer onboarding). This creates margin lift, platform leverage, and
                        compound returns across sectors.
                    </p>
                </div>
            </div>

            <div className="bg-gray-900 bg-opacity-50 p-8 rounded-lg my-16">
                <h2 className="text-2xl font-bold mb-6">Core Investment Strategies</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {strategies.map((strategy, index) => (
                        <div key={index} className="flex">
                            <div className="mr-4 h-12 w-12 bg-accent flex items-center justify-center rounded-full flex-shrink-0">
                                <span className="font-bold text-lg">{index + 1}</span>
                            </div>
                            <div>
                                <h3 className="font-bold text-xl mb-2">{strategy.title}</h3>
                                <p className="text-gray-300">{strategy.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* <div className="my-16">
                <h2 className="text-3xl font-bold mb-8">Target Sectors</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-gray-900 bg-opacity-30 p-6 rounded-lg hover:bg-opacity-50 transition-all transform hover:scale-105">
                        <h3 className="font-bold text-xl mb-3">Tech-Enabled Services</h3>
                        <p className="text-gray-300">Fragmented services markets ready for AI optimization (e.g., accounting, clinics, auto repair, HR/PEO).</p>
                    </div>
                    <div className="bg-gray-900 bg-opacity-30 p-6 rounded-lg hover:bg-opacity-50 transition-all transform hover:scale-105">
                        <h3 className="font-bold text-xl mb-3">Vertical SaaS & Developer Tools</h3>
                        <p className="text-gray-300">Software with embedded customer retention and cross-sell potential.</p>
                    </div>
                    <div className="bg-gray-900 bg-opacity-30 p-6 rounded-lg hover:bg-opacity-50 transition-all transform hover:scale-105">
                        <h3 className="font-bold text-xl mb-3">Data & Analytics Infrastructure</h3>
                        <p className="text-gray-300">Enabling actionable insights, benchmarking, and AI automation across industries.</p>
                    </div>
                </div>
            </div>

            <div className="mt-24 bg-accent p-12 rounded-lg text-center">
                <h2 className="text-3xl font-bold mb-6">Our Investment Criteria</h2>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center mt-8">
                    <div>
                        <div className="text-2xl font-bold mb-2">$2-20M</div>
                        <p>ARR or EBITDA</p>
                    </div>
                    <div>
                        <div className="text-2xl font-bold mb-2">70%+</div>
                        <p>Gross Margins (Software) / 15-40% EBITDA (Services)</p>
                    </div>
                    <div>
                        <div className="text-2xl font-bold mb-2">15%+</div>
                        <p>Growth with AI acceleration potential</p>
                    </div>
                    <div>
                        <div className="text-2xl font-bold mb-2">B2B Focus</div>
                        <p>Vertical platform potential</p>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default ThesisPage; 